function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M10 19.25C4.9 19.25.75 15.1.75 10S4.9.75 10 .75 19.25 4.9 19.25 10 15.1 19.25 10 19.25z",
  stroke: "currentColor",
  strokeWidth: 1.5
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M14.375 10.875h-8.75c-.345 0-.625-.336-.625-.75s.28-.75.625-.75h8.75c.345 0 .625.336.625.75s-.28.75-.625.75z",
  fill: "currentColor"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M10.125 15c-.414 0-.75-.28-.75-.625v-8.75c0-.345.336-.625.75-.625s.75.28.75.625v8.75c0 .345-.336.625-.75.625z",
  fill: "currentColor"
});

function SvgIconPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2, _ref3);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEwIDE5LjI1QzQuODk5OTkgMTkuMjUgMC43NSAxNS4xIDAuNzUgMTBDMC43NSA0Ljg5OTk5IDQuODk5OTkgMC43NSAxMCAwLjc1QzE1LjEgMC43NSAxOS4yNSA0Ljg5OTk5IDE5LjI1IDEwQzE5LjI1IDE1LjEgMTUuMSAxOS4yNSAxMCAxOS4yNVoiIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2Utd2lkdGg9IjEuNSIvPgo8cGF0aCBkPSJNMTQuMzc1IDEwLjg3NUg1LjYyNUM1LjI4IDEwLjg3NSA1IDEwLjUzOSA1IDEwLjEyNUM1IDkuNzExIDUuMjggOS4zNzUgNS42MjUgOS4zNzVIMTQuMzc1QzE0LjcyIDkuMzc1IDE1IDkuNzExIDE1IDEwLjEyNUMxNSAxMC41MzkgMTQuNzIgMTAuODc1IDE0LjM3NSAxMC44NzVaIiBmaWxsPSJjdXJyZW50Q29sb3IiLz4KPHBhdGggZD0iTTEwLjEyNSAxNUM5LjcxMSAxNSA5LjM3NSAxNC43MiA5LjM3NSAxNC4zNzVWNS42MjVDOS4zNzUgNS4yOCA5LjcxMSA1IDEwLjEyNSA1QzEwLjUzOSA1IDEwLjg3NSA1LjI4IDEwLjg3NSA1LjYyNVYxNC4zNzVDMTAuODc1IDE0LjcyIDEwLjUzOSAxNSAxMC4xMjUgMTVaIiBmaWxsPSJjdXJyZW50Q29sb3IiLz4KPC9zdmc+Cg==";
export { SvgIconPlus as ReactComponent };